const locale = {
  placeholder: 'Zeit auswÃ¤hlen',
};

export default locale;
